import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import getLogo from './getLogo'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: '12pt',
    padding: '2cm',
    textAlign: 'justify'
  },
  logo: {
    width: 50,
    height: 50,
  },
  title:{
    fontSize: '14pt',
  },
  data: {
    color: 'darkblue'
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    maxWidth: '100%',
    marginBottom: 4,
  },
  content:{
    lineHeight: '2pt',
  },
  field: {
    fontSize: '11pt',
    color: 'darkblue'
  },
  center:{
    textAlign: 'center',
    marginTop: 20,
  },
  label: {
    fontSize: '9pt',
    marginRight: 2,
    width: 60,
  },
  textView: {
    maxWidth: '100%',
  },
  text: {
    color: 'darkblue',
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableHead: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: 'lightgrey',
    fontSize: '14pt',
  },
  tableCol: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol1: {
    width: "55%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
  },
  tableColTotal: {
    width: "85%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    padding: 5,
  },
});


const feesPdf = ({ nome, cirurgiao, hospital, convenio, date, cpf, procedimentos,
                   orcamento, acomodacao, cidade, estado, logoName
}) => (

<Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
  <Page style={styles.page} wrap={false}>
    <View style={styles.row}>
      <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
      <View style={styles.center}>
        <Text style={styles.title}>PREVISÃO ORÇAMENTÁRIA</Text>
        <Text style={styles.title}>PARA PROCEDIMENTO ANESTÉSICO</Text>
      </View>
    </View>

    <View style={styles.block}>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>Nome</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{nome}</Text></View>
      </View>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>CPF</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{cpf}</Text></View>
      </View>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>Cirurgiã(o)</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{cirurgiao}</Text></View>
      </View>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>Hospital</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{hospital}</Text></View>
      </View>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>Convênio</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{convenio}</Text></View>
      </View>
      <View style={styles.row}>
        <View style={styles.labelView}><Text style={styles.label}>Acomodação</Text></View>
        <View style={styles.textView}><Text style={styles.text}>{acomodacao}</Text></View>
      </View>
    </View>

    <View style={styles.table}>
      <View style={styles.tableHead}>
        <View style={[styles.tableCol1, {borderLeftWidth: 0}]}>
          <Text style={styles.tableCell}>PROCEDIMENTO(S)</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>PORTE</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>%</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>VALOR (R$)</Text>
        </View>
      </View>
      {procedimentos.split("\n").map((procedimento, index) => (
        <View style={styles.tableRow} key={index+procedimento}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>{procedimento}</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{orcamento[`porteLinha${index+1}`] || ""}</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{Number(orcamento[`percentualLinha${index+1}`] || 1) * 100}</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{isNaN(orcamento[`valorLinha${index+1}`]) ? "" : ((Math.round(orcamento[`valorLinha${index+1}`]*100)/100).toFixed(2) || "")}</Text>
          </View>
        </View>
      ))}
      <View style={styles.tableRow}>
        <View style={styles.tableColTotal}>
          <Text style={[styles.tableCell, {textAlign: 'center'}]}>TOTAL:</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>R$ {isNaN(orcamento.total) ? "" : (orcamento.total || "")}</Text>
        </View>
      </View>
      </View>

      <View style={styles.block}>
        <View style={styles.row}>
          <View style={styles.labelView}><Text style={styles.label}>Observação:</Text></View>
        </View>
        <View style={styles.row}>
          <View style={styles.textView}><Text style={styles.text}>{orcamento.obsOrcamento}</Text></View>
        </View>
      </View>

      <View>
        <View style={styles.row}>
          <Text>Este valor poderá sofrer alterações nos seguintes casos:</Text>
        </View>
        <View style={styles.row}>
          <Text>- Se houver necessidade de outro(s) procedimento(s) cirúrgico(s) adicional(is) e diferente(s) do(s) inicialmente programado(s)</Text>
        </View>
        <View style={styles.row}>
          <Text>- Se acontecer no período noturno (das 19h às 7h) ou em qualquer horário nos fins de semana ou feriado</Text>
        </View>
        <View style={styles.row}>
        <Text>- Se houver opção por acomodação superior à anteriormente prevista</Text>
        </View>
      </View>

    <View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO PACIENTE
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO MÉDICO ANESTESIOLOGISTA
      </Text>
    </View>
    <View style={styles.center}>
      <Text style={styles.data}>
        {cidade && `${cidade}/${estado},`} {date.toLocaleDateString()}
      </Text>
    </View>
   </View>
  </Page>
</Document>
);

export default feesPdf
